import CryptoJS from "crypto-js";

const BASE64_KEY = process.env.REACT_APP_BASE64_KEY;

const decryptData = (data, key) => {
  const dataBytes = CryptoJS.enc.Base64.parse(data);
  const iv = CryptoJS.lib.WordArray.create(dataBytes.words.slice(0, 4));
  const ciphertext = CryptoJS.lib.WordArray.create(dataBytes.words.slice(4));

  const decryptedBytes = CryptoJS.AES.decrypt({ ciphertext }, key, { iv });
  const decryptedText = CryptoJS.enc.Utf8.stringify(decryptedBytes);

  return decryptedText;
};

export const decryptResponse = (data, only_response = false) => {
  try {
    const key = CryptoJS.enc.Base64.parse(BASE64_KEY);
    const response_data = data?.response_data;
    const response_message = data?.response_message;

    if (!only_response) {
      const decryptedResponseData = decryptData(response_data, key);
      const response = {
        response_message,
        response_data: JSON.parse(decryptedResponseData),
      };
      return response;
    } else {
      const decryptedResponseData = decryptData(data, key);
      return JSON.parse(decryptedResponseData);
    }
  } catch (error) {
    throw error;
  }
};
